<template>
	<InfoTiles stacked :tiles="tiles" :min-width="200">
		<template #value-documents>
			<div class="d-flex flex-wrap ga-2">
				<v-chip v-for="document in campaign.documents" :key="document.id" prepend-icon="description" size="small" color="primary" @click="ops.run({ type: 'openDocument', documentId: document.id })">{{ document.label }}</v-chip>
			</div>
		</template>
	</InfoTiles>
</template>

<script setup>
import { toRef } from 'vue';
import InfoTiles from '@/components/common/InfoTiles.vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { usePromoCampaign } from '@/composables/usePromoCampaign';

const props = defineProps({
	campaign: { type: Object, required: true },
});

const { ops } = usePromoStep();
const { tiles } = usePromoCampaign(toRef(props, 'campaign'));
</script>
